export default "/images/vendor/flag-icon-css/flags/4x3/ml.svg?18083e46073cc9f5f58fda59451b15f9";